<template>
    <div id="sendMessage">
        <div class="second-header-wrap">
            <el-radio-group size="medium" v-model="panel" @change="changeTab" >
                <el-radio-button label="p1">批量发送</el-radio-button>
                <el-radio-button label="p2">单个发送</el-radio-button>
            </el-radio-group>
            <el-button size="medium" @click="sendMessage" type="primary">发送</el-button>
            <div class="right-part">
                <el-button size="medium" type="text" @click="toMessageMan">短信管理</el-button>
            </div>
        </div>
        <div  v-if="panel === 'p1'">
            <div>
                <el-form
                    :model="batchData"
                    label-width="150px"
                    :rules="batchRules"
                    ref="batch"
                >
                    <el-form-item label="发送目标类型" prop="sendType">
                        <div style="width: 500px;">
                            <el-radio-group v-model="batchData.sendType">
                                <el-radio :label="0">全部报名学生</el-radio>
                                <el-radio :label="1">通过审核学生</el-radio>
                                <el-radio :label="2">未通过审核学生</el-radio>
                            </el-radio-group>
                        </div>
                    </el-form-item>
                    <el-form-item label="分段范围" prop="scope">
                        <el-checkbox v-model="isRange">是否分段范围</el-checkbox>
                        <span v-show="isRange">
                                <el-input-number type="number" :precision="0" :min="0" :max="batchData.endScope"
                                                 style="width: 132px;" v-model="batchData.startScope"></el-input-number>
                                到
                                <el-input-number type="number" :precision="0" :min="batchData.startScope"
                                                 :max="signupTotal" style="width:132px;"
                                                 v-model="batchData.endScope"></el-input-number>
                            </span>
                    </el-form-item>
                    <el-form-item label="操作类型" prop="optType">
                        <el-radio-group v-model="batchData.optType">
                            <el-radio :label="1">按通知发送</el-radio>
                            <el-radio :label="2">按群组发送</el-radio>
                            <el-radio :label="3">按审核意见发送</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="报名公告" prop="noticeId">
                        <el-select @change="noticeChange" v-model="batchData.noticeId" placeholder="请选择">
                            <el-option v-for="noticeItem in noticeList" :label="noticeItem.title"
                                       :value="noticeItem.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-show="batchData.optType === 3" label="审核意见" prop="examineCode">
                        <el-select v-model="batchData.examineCode" placeholder="请选择">
                            <el-option
                                v-for="item in reviewOptionList"
                                :key="item.code"
                                :label="item.value"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-show="batchData.optType === 2" label="分组" prop="groupId">
                        <el-select v-model="batchData.groupId" placeholder="请选择">
                            <el-option v-for="groupItem in groupList" :label="groupItem.groupName"
                                       :value="groupItem.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="短信模板" prop="tempId">
                        <el-select @change="getTemp" v-model="batchData.tempId" placeholder="请选择">
                            <el-option v-for="tempItem in templateList" :label="tempItem.title"
                                       :value="tempItem.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模板" prop="temp">
                        <template v-for="(segment, index) in temp">
                            <span v-if="segment.text !== ''">{{segment.text}}</span>
                            <el-input style="width: 80px;" v-else v-model="tempAnswer[index].text"></el-input>
                        </template>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div  v-if="panel === 'p2'">
            <div>
                <el-form
                    :model="singleData"
                    label-width="200px"
                    :rules="singleRules"
                    ref="single"
                >
                    <el-form-item label="发送手机号（用换行分割）" prop="receiveUser">
                        <div style="width: 500px;">
                            <el-input type="textarea" rows="8" v-model="singleData.receiveUser"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item v-show="false" label="操作类型">
                        <el-radio-group v-model="singleData.sendType">
                            <el-radio :label="1">按通知发送</el-radio>
                            <el-radio :label="2">按群组发送</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item v-show="false" label="公告">
                        <el-select @change="noticeChange" v-model="singleData.noticeId" placeholder="请选择">
                            <el-option v-for="noticeItem in noticeList" :label="noticeItem.title"
                                       :value="noticeItem.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-show="false" label="分组">
                        <el-select v-model="singleData.groupId" placeholder="请选择">
                            <el-option v-for="groupItem in groupList" :label="groupItem.groupName"
                                       :value="groupItem.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="短信模板" prop="smsTempId">
                        <el-select @change="getTemp" v-model="singleData.smsTempId" placeholder="请选择">
                            <el-option v-for="tempItem in templateList" :label="tempItem.title"
                                       :value="tempItem.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模板" prop="temp">
                        <template v-for="(segment, index) in temp">
                            <span v-if="segment.text !== ''" v-html="segment.text"></span>
                            <el-input style="width: 80px;" v-else v-model="tempAnswer[index].text"></el-input>
                        </template>
                    </el-form-item>
                </el-form>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {
        findSchoolDicsByCode,
    } from '@/api/common';
    import {
        singleSendMessage,
        batchSendMessage,
        getSchoolEnrolNoticeList,
        getNoticeGroupList,
        queryTemplateBySchoolId,
        getNoticeApplyStuPageList
    } from '@/api/primary/setting';

    export default {
        name: "SendMessage",
        computed: {
            ...mapGetters(['schoolInfo'])
        },
        data: function () {
            const tempValidator = (rule, value, callback) => {
                if (this.tempAnswer.some(item => item.text === '')) {
                    callback(new Error('请正确填写模板！'));
                } else {
                    callback();
                }
            };
            const scopeValidator = (rule, value, callback) => {
                if (!this.isRange) {
                    callback();
                } else {
                    if (this.batchData.endScope === '' || this.batchData.startScope === '') {
                        callback(new Error('请正确填写范围！'));
                    } else {
                        callback();
                    }
                }
            };

            const groupValidator1 = (rule, value, callback) => {
                if (this.batchData.optType !== 2) {
                    callback();
                } else {
                    if (!this.batchData.groupId) {
                        callback(new Error('分组不能为空！'));
                    } else {
                        callback();
                    }
                }
            };

            const groupValidator2 = (rule, value, callback) => {
                if (this.singleData.sendType === 1) {
                    callback();
                } else if (this.singleData.sendType === 2) {
                    if (!this.singleData.groupId) {
                        callback(new Error('分组不能为空！'));
                    } else {
                        callback();
                    }
                }
            };

            const examineCodeValidator = (rule, value, callback) => {
                if (this.batchData.optType !== 3) {
                    callback();
                } else {
                    if (!this.batchData.examineCode) {
                        callback(new Error('审核意见不能为空！'));
                    } else {
                        callback();
                    }
                }
            };

            return {
                panel: 'p1',
                isRange: false,
                signupTotal: 0,
                batchData: {
                    endScope: 1,
                    startScope: 1,
                    optType: 1,
                    noticeId: '',
                    groupId: '',
                    sendTarget: '',
                    sendType: 0,
                    tempContent: '',
                    tempId: '',
                    examineCode: ''
                },
                singleData: {
                    noticeId: '',
                    groupId: '',
                    sendType: 1,
                    smsContent: '',
                    smsTempId: '',
                    receiveUser: ''
                },
                temp: [],
                tempAnswer: [],
                batchRules: {
                    sendType: [{
                        required: true, message: '发送目标类型不能为空', trigger: 'blur'
                    }],
                    scope: [{
                        trigger: 'blur', validator: scopeValidator
                    }],
                    optType: [{
                        required: true, message: '操作类型不能为空', trigger: 'blur'
                    }],
                    noticeId: [{
                        required: true, message: '通知不能为空', trigger: 'blur'
                    }],
                    tempId: [{
                        required: true, message: '模板不能为空', trigger: 'blur'
                    }],
                    groupId: [{
                        required: true, validator: groupValidator1, trigger: 'blur'
                    }],
                    temp: [{
                        required: true, trigger: 'blur', validator: tempValidator
                    }],
                    examineCode: [{
                        required: true, validator: examineCodeValidator, trigger: 'blur'
                    }],
                },
                singleRules: {
                    sendType: [{
                        required: true, message: '发送目标类型不能为空', trigger: 'blur'
                    }],
                    receiveUser: [{
                        required: true, message: '发送目标不能为空', trigger: 'blur'
                    }],
                    noticeId: [{
                        required: true, message: '通知不能为空', trigger: 'blur'
                    }],
                    smsTempId: [{
                        required: true, message: '模板不能为空', trigger: 'blur'
                    }],
                    groupId: [{
                        required: true, validator: groupValidator2, trigger: 'blur'
                    }],
                    temp: [{
                        required: true, trigger: 'blur', validator: tempValidator
                    }],
                },
                noticeList: [],
                groupList: [],
                templateList: [],
                reviewOptionList: []
            }
        },
        created() {
            findSchoolDicsByCode({
                dicCode: 'examineOptions',
                schoolId: this.schoolInfo.id
            })
                .then(res => res.data)
                .then(data => {
                    if (data.data.length !== 0 && this.batchData.examineCode === '') {
                        this.batchData.examineCode = data.data[0].code;
                    }
                    this.reviewOptionList = data.data;
                });
            queryTemplateBySchoolId()
                .then(res => res.data)
                .then(data => {
                    this.templateList = data.data.filter(item => item.statusCode == 0);
                    if (this.templateList.length !== 0) {
                        this.batchData.tempId = this.templateList[0].id;
                        this.singleData.smsTempId = this.templateList[0].id;
                        this.getTemp()
                    }
                });
            getSchoolEnrolNoticeList({
                searchVal: '',
                state: 2
            })
                .then(res => res.data)
                .then(data => {
                    this.noticeList = data.data;
                    if (data.data.length !== 0) {
                        this.batchData.noticeId = data.data[0].id;
                        this.singleData.noticeId = data.data[0].id;
                        this.getNoticeGroupListFunc();
                        this.getNoticeApplyStuPageListFunc();
                    }
                })
        },
        methods: {

            noticeChange() {
                this.batchData.endScope = 1;
                this.batchData.startScope = 1;
                this.getNoticeGroupListFunc();
                this.getNoticeApplyStuPageListFunc();
            },
            changeTab() {
                this.getTemp();
            },
            getNoticeApplyStuPageListFunc() {
                getNoticeApplyStuPageList({
                    pageNo: 1,
                    pageSize: 10,
                    searchVal: '',
                    state: 0,
                    noticeId: this.panel === 'p1' ? this.batchData.noticeId : this.singleData.noticeId
                })
                    .then(res => res.data)
                    .then(data => {
                        this.signupTotal = data.data.pagination.total;
                    })
            },
            sendMessage() {
                if (this.panel === 'p1') {
                    this.$refs.batch.validate((valid) => {
                        if (valid) {
                            const args = {};
                            args.rangeChecked = this.isRange ? 1 : 0;
                            args.startScope = this.isRange ? this.batchData.startScope : 0;
                            args.endScope = this.isRange ? this.batchData.endScope : 0;
                            args.groupId = this.batchData.groupId || 0;
                            args.noticeId = this.batchData.noticeId;
                            args.sendTarget = ['全部报名学生', '通过审核学生', '未通过审核学生'][this.batchData.sendType];
                            args.sendType = this.batchData.sendType;
                            args.optType = this.batchData.optType;
                            args.tempContent = this.tempAnswer.map(item => item.text).join('');
                            args.tempId = this.batchData.tempId;
                            args.examineCode = this.batchData.examineCode
                            batchSendMessage(args)
                                .then(res => res.data)
                                .then(data => {
                                    if (data.result) {
                                        this.$message({
                                            message: '已发送短信',
                                            type: 'success'
                                        });
                                    } else {
                                        this.$message.error(data.msg);
                                    }
                                });
                        }
                    });
                } else {
                    let phoneValid = true;
                    if (this.singleData.receiveUser) {
                        const phoneList = this.singleData.receiveUser.split('\n');
                        phoneList.forEach(phone => {
                            if (!/^0?1[345789][0-9]\d{8}$/.test(`${phone}`.trim())) {
                                phoneValid = false;
                                return false;
                            }
                        });
                    }
                    if(!phoneValid) {
                        this.$message({
                            type: 'error',
                            message: '格式不正确'
                        });
                        return false;
                    }
                    this.$refs.single.validate((valid) => {
                        if (valid) {
                            const args = {};
                            args.groupId = 0;
                            args.noticeId = 0;
                            args.sendType = 0;
                            args.receiveUser = this.singleData.receiveUser.split('\n').join('#');
                            args.smsContent = this.tempAnswer.map(item => item.text).join('');
                            args.smsTempId = this.singleData.smsTempId;

                            singleSendMessage(args)
                                .then(res => res.data)
                                .then(data => {
                                    if (data.result) {
                                        this.$message({
                                            message: '已发送短信',
                                            type: 'success'
                                        });
                                    } else {
                                        this.$message.error(data.msg);
                                    }
                                });
                        }
                    });
                }
            },
            getNoticeGroupListFunc() {
                getNoticeGroupList({
                    noticeId: this.panel === 'p1' ? this.batchData.noticeId : this.singleData.noticeId
                })
                    .then(res => res.data)
                    .then(data => {
                        this.groupList = data.data;
                        if (data.data.length !== 0) {
                            this.batchData.groupId = data.data[0].id;
                            this.singleData.groupId = data.data[0].id;
                        }
                    })
            },
            getTemp() {
                let id = null;
                if (this.panel === 'p1') {
                    id = this.batchData.tempId;
                } else {
                    id = this.singleData.smsTempId;
                }

                const template = this.templateList.find(item => item.id === id);
                if(template) {
                    const temp = template.content.split(/[{}]/).filter(item => item !== '');
                    console.log('temp', temp);
                    this.temp = temp.map(item => ({
                        text: /^\d+$/.test(item) ? '' : item
                    }));
                    this.tempAnswer = temp.map(item => ({
                        text: /^\d+$/.test(item) ? '' : item
                    }));
                }
            },
            toMessageMan() {

            }
        }
    }
</script>

<style scoped>

</style>
<style lang="scss">
    #sendMessage {
        .el-form-item__content {
            /*line-height: 40px !important;*/
        }
    }

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        background-color: #fff;
        z-index: 1000;
        padding: 20px 0 0 0;
        margin-bottom: 16px;
    }
    .right-part {
        display: inline-block;
        margin-left: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/setting/SendMessage.vue